var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{attrs:{"colored-border":"","border":"top","color":"color","elevation":"2"}},[_c('p',{staticClass:"text-center py-16"},[_c('img',{attrs:{"src":require("@/assets/images/data_empty.png")}})]),_c('h1',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }